import {FC} from 'react'
import {ListViewProvider} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {KTCard} from '../../../../_metronic/helpers'
import {RolesListHeader} from './components/header/RolesListHeader'
import {RolesTable} from './table/RolesTable'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Col, Row} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import { checkPermission } from 'app/utils/checkPermission'

const RolesList: FC = () => {
  const navigate = useNavigate()

  return (
    <>
      <PageTitle>Role list</PageTitle>
      <Col className='position-absolute me-5 end-0 tp-btn-mn'>
        {(checkPermission('Roles','create') && ( 
          
             <button 
              type="button" 
              onClick={() => navigate('/role-management/add')}
              className='btn btn-sm fs-5 mt-9 me-5 btn btn-primary'
            >
              Add Role
            </button> 
          )
      )}
           
      </Col>
      <QueryRequestProvider>
        <QueryResponseProvider>
          <ListViewProvider>
            <KTCard>
              <RolesListHeader />
              <RolesTable />
            </KTCard>
          </ListViewProvider>
        </QueryResponseProvider>
      </QueryRequestProvider>
    </>
  )
}

export {RolesList} 